import { AppLayout } from "components/AppLayout/AppLayout";
import { QuickNavModal } from "components/QuickNavModal/QuickNavModal";
import { COMMUNITY_QUICK_NAV_PAGES } from "constants/quickNav/community";
import { ComingSoon } from "components/ComingSoon/ComingSoon";
import { INKLE_WEBSITE_URL } from "constants/base";
import GroupSelect from "components/dashboard/sideBar/groupSelect";
import PerksTab from "components/deals/PerksTab";
import PerkStepController from "components/deals/selfServePerk/perkStepController";
import { Blog } from "components/icons/LeftNav/Community/Blog";
import { Events } from "components/icons/LeftNav/Community/Events";
import { FAQs } from "components/icons/LeftNav/Community/FAQs";
import { Forum } from "components/icons/LeftNav/Community/Forum";
import { Handbook } from "components/icons/LeftNav/Community/Handbook";
import { Perks } from "components/icons/LeftNav/Community/Perks";
import { Home } from "components/icons/LeftNav/Home";
import { InkleCommunityLogo } from "components/icons/Logos/InkleCommunityLogo";
import { InkleCommunitySymbol } from "components/icons/Logos/InkleCommunitySymbol";
import { NavAcrossApps } from "components/NavAcrossApps/NavAcrossApps";
import { RoutesAccrossApps } from "components/RoutesAcrossApps/RoutesAcrossApps";
import {
  LeftBar,
  LeftBarItem,
  LeftBarLogo,
  LeftBarSeparator,
  LeftBarTag,
} from "components/Sidebar/LeftBar";
import { SidebarStickyGroup } from "components/Sidebar/SidebarStickyGroup";
import { TopBar } from "components/TopBar/TopBar";
import { FOREIGN_CA } from "constants/onBoarding";
import { useAuth } from "hooks/useAuth";
import { Switch, useRouteMatch } from "react-router-dom";
import { RestrictedRoute } from "RestrictedRoute";
import { DashboardBanner } from "signInSignUp/DashboardBanner";
import "static/styles/containers/dashboard.css";
import { CommunityHome } from "../Resources/CommunityHome";
import { useCurrentAppContext } from "contexts/CurrentAppContext";
import { useEffect } from "react";
import { HandbookApp } from "components/apps/handbook";

export const Navbar = () => {
  const { type } = useAuth();

  return (
    <div className="t-h-full t-flex t-flex-col t-justify-between">
      <div>
        {type === FOREIGN_CA && (
          <div className="t-m-2">
            <GroupSelect />
          </div>
        )}
        <LeftBarItem exact to="/" icon={Home}>
          Home
        </LeftBarItem>

        <LeftBarItem to="/perks" icon={Perks}>
          Perks
        </LeftBarItem>
        <LeftBarItem
          suffix={<LeftBarTag type="blue">Upcoming</LeftBarTag>}
          to="/forum"
          icon={Forum}
        >
          Forum
        </LeftBarItem>
        <LeftBarItem to="/handbook" icon={Handbook}>
          Handbooks
        </LeftBarItem>
        <LeftBarItem
          useParentPath={false}
          to={`${INKLE_WEBSITE_URL}resources/events/talks`}
          icon={Events}
        >
          Events
        </LeftBarItem>
        <LeftBarItem
          useParentPath={false}
          to={`${INKLE_WEBSITE_URL}services`}
          icon={FAQs}
        >
          FAQs
        </LeftBarItem>
        <LeftBarItem
          useParentPath={false}
          to={`${INKLE_WEBSITE_URL}resources/blog`}
          icon={Blog}
        >
          Blogs
        </LeftBarItem>
      </div>
    </div>
  );
};

export const CommunitygroupDashboard = () => {
  const { path } = useRouteMatch();
  const { dispatch: currentAppDispatch } = useCurrentAppContext();

  useEffect(() => {
    currentAppDispatch({
      type: "SET_CURRENT_APP",
      payload: { currentApp: "Community" },
    });
  }, []);

  return (
    <AppLayout
      sidebar={
        <LeftBar
          logo={
            <LeftBarLogo
              logo={InkleCommunityLogo}
              symbol={InkleCommunitySymbol}
            />
          }
          showCollapse
          stickyNav={<SidebarStickyGroup />}
        >
          <Navbar />
        </LeftBar>
      }
      topbar={
        <TopBar
          logo={
            <LeftBarLogo
              logo={InkleCommunityLogo}
              symbol={InkleCommunitySymbol}
            />
          }
          nav={<Navbar />}
          stickyNav={<SidebarStickyGroup />}
        />
      }
      banner={<DashboardBanner />}
    >
      <QuickNavModal pages={COMMUNITY_QUICK_NAV_PAGES} />
      <Switch>
        <RestrictedRoute
          exact
          path={`${path}/perks/create`}
          component={PerkStepController}
        />
        <RestrictedRoute path={`${path}/perks`} component={PerksTab} />

        <RestrictedRoute exact path={`${path}/forum`} component={ComingSoon} />
        <RestrictedRoute
          exact
          path={`${path}/handbook`}
          component={HandbookApp}
        />

        <RestrictedRoute exact path={path} component={CommunityHome} />

        <RoutesAccrossApps />
      </Switch>
    </AppLayout>
  );
};
